export default __webpack_public_path__ + "static/media/adminstration.e6ab8f7a.svg";